/**
 * ChatGPTRoute: /resources/chatgpt
 *
 * The page itself is EcosystemPath; the steps are data in lib/ecosystemData.
 * This file used to carry its own copy of the layout, its own inline styles
 * and its own fonts, which is how fifteen pages drifted apart.
 */

import EcosystemPath from "@/components/EcosystemPath";
import NotFound from "@/pages/NotFound";
import { toolPath } from "@/lib/ecosystemData";

export default function ChatGPTRoute() {
  const path = toolPath("chatgpt");
  if (!path) return <NotFound />;
  return <EcosystemPath path={path} />;
}
